module.exports = __webpack_public_path__ + "static/media/x_icon.6e4238b3.svg";